import React from 'react';
import measureLineHeight from 'line-height';
import styles from './date.scss';
import { fontFamilies } from '../constants';
import { parseDateFormat } from '../../../common/utils/date-format';

export default class Date extends React.PureComponent {

  focusWrapper = React.createRef();

  textRef = React.createRef();

  measureLineHeight= () => measureLineHeight(this.textRef.current);

  getBoundingClientRect = () => this.focusWrapper.current.getBoundingClientRect();

  focus = (...args) => this.focusWrapper.current.focus(...args);

  render() {
    const { fieldData, tabIndex = 0 } = this.props;
    const readOnly = fieldData.readOnly || false;

    const style = {
      fontSize: fieldData.fontSize && Number(fieldData.fontSize),
    };

    if (fieldData.fontFamily && fontFamilies[fieldData.fontFamily]) {
      style.fontFamily = fontFamilies[fieldData.fontFamily];
    }

    return (
      <div
        data-qa-ref={`${fieldData.type}-input`}
        className={styles.placeholder}
        ref={this.focusWrapper}
        tabIndex={readOnly ? -1 : tabIndex}
        style={{ outline: 'none' }}
      >
        <p className={styles.p} style={style} ref={this.textRef}>
          {parseDateFormat(fieldData.value)}
        </p>
      </div>
    );
  }
}
